import React from 'react';
import { Icon, type IconName } from '../../components/ui/Icon';

export const PaymentOptionCard: React.FC<{
  active: boolean;
  onClick: () => void;
  icon: IconName;
  title: string;
  sub: string;
  right?: React.ReactNode;
}> = ({ active, onClick, icon, title, sub, right }) => (
  <button
    type="button"
    onClick={onClick}
    className="card card-hover"
    style={{
      padding: 14,
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      cursor: 'pointer',
      borderColor: active ? 'var(--ink)' : 'var(--line)',
      borderWidth: active ? 2 : 1,
      width: '100%',
      textAlign: 'left',
      background: 'var(--bg-elev)',
      fontFamily: 'inherit',
    }}
  >
    <div
      style={{
        width: 36,
        height: 36,
        borderRadius: 8,
        background: 'var(--bg-tint)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      <Icon name={icon} size={18} />
    </div>
    <div style={{ flex: 1 }}>
      <div style={{ fontWeight: 600, fontSize: 14 }}>{title}</div>
      <div className="muted" style={{ fontSize: 12 }}>
        {sub}
      </div>
    </div>
    {right}
    <div
      style={{
        width: 20,
        height: 20,
        borderRadius: '50%',
        border: `2px solid ${active ? 'var(--ink)' : 'var(--line-strong)'}`,
        background: active ? 'var(--ink)' : 'transparent',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
      }}
    >
      {active && (
        <div style={{ width: 8, height: 8, borderRadius: '50%', background: '#fff' }} />
      )}
    </div>
  </button>
);
